import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'wrongBarcodeDialog.title',
    defaultMessage: 'Wrong barcode',
    description: 'Title of the wrong dialog',
  },
  message: {
    id: 'wrongBarcodeDialog.message',
    defaultMessage:
      'The barcode you have scanned is a different barcode than the barcode of the requested product. Check if you scanned the right product.',
    description: 'Message of the wrong barcode dialog',
  },
  actions: {
    close: {
      id: 'actions.close',
      defaultMessage: 'Close',
      description: 'Label of the close action of the wrong barcode dialog',
    },
  },
};

export default defineMessages(translations);
